import { SearchTemplate, SearchTreeNode } from '@/types';
import { ElectorateRecordResult } from '@/types/filterCriteriaRecords';

import { FieldMetaData } from '@components/LoadSearchTemplateDialog/templateFormControls/types';
import { FilterNameAndFieldMappedValue } from '@components/LoadSearchTemplateDialog/types';

export type FilterFieldChangePayload = FilterNameAndFieldMappedValue & {
  fieldMetaData: FieldMetaData;
};

export type LoadSearchTemplateDialogProps = {
  searchTemplate: SearchTemplate;
  onClose: () => void;
  /** Called when user cancels (not when Apply is clicked). Use to revert state when opened from Edit criteria Restart. */
  onCloseWithoutApply?: () => void;
  fromPreview?: boolean;
  fromRestart?: boolean;
  previousSelectionsTree?: SearchTreeNode;
};

export const fieldHash = (nodeId: string, filterNameAndField: string) =>
  `${nodeId}-${filterNameAndField}`;

export type ElectionElectorates = {
  electionId: number;
  electorates: { id: number; label: string }[];
  electorateValue: ElectorateRecordResult[];
};

export type MapNodeIdToElectionElectorates = Record<string, ElectionElectorates | null>;
